export default "__VITE_ASSET__DJStkDdz__"